export default "/images/394a9018ea65940471f9df903481ad46.png";